import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Flex } from '../../../layout/Flex.mjs';
import TextField from '../../../text-field/TextField.mjs';
import { Tooltip } from '../../../tooltip/Tooltip.mjs';
import { textField, textFieldWithErrorTooltip } from '../../datePicker.vanilla.mjs';

function TextFieldWithErrorTooltip({
  errorTooltip,
  className: classNameFromProps,
  ...textFieldProps
}) {
  const hasError = errorTooltip !== void 0;
  return /* @__PURE__ */ jsxs(Tooltip, { open: hasError, children: [
    /* @__PURE__ */ jsx(Tooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
      TextField,
      {
        variant: "solid",
        state: hasError ? "error" : void 0,
        size: "small",
        className: classNames(textField, classNameFromProps),
        ...textFieldProps
      }
    ) }),
    /* @__PURE__ */ jsx(
      Tooltip.Content,
      {
        side: "top",
        prefersReducedMotion: "reduce",
        hideWhenDetached: true,
        children: errorTooltip
      }
    )
  ] });
}
const Wrapper = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      align: "center",
      className: classNames(textFieldWithErrorTooltip, className),
      ...props
    }
  );
};
TextFieldWithErrorTooltip.Wrapper = Wrapper;

export { TextFieldWithErrorTooltip as default };
//# sourceMappingURL=TextFieldWithErrorTooltip.mjs.map
